import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { TemplateModule } from '../template-popup/template.module';
import { FooterComponent } from './footer.component';

@NgModule({
    declarations: [FooterComponent],
    imports: [
        TemplateModule,
        CommonModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
    ],
    exports: [FooterComponent],
})
export class FooterModule {}
